import SubstrateEvent from '../data/schema/SubstrateEvent';
import SubstrateSearchScenario from '../data/schema/SubstrateSearchScenario';
import getSubstrateSearchEndpoint from '../helpers/getSubstrateSearchEndpoint';
import { makePostRequest } from 'owa-ows-gateway';
import buildQueryParams from 'owa-search-service/lib/helpers/buildQueryParams';

export interface EventsBatch {
    [traceId: string]: SubstrateEvent[];
}

export let batch: EventsBatch = null;

export default function substrateSearchLogEventsOperation(
    traceId: string,
    event: SubstrateEvent,
    substrateSearchScenario: SubstrateSearchScenario
) {
    event.Attributes.forEach(element => {
        if (typeof element.Value !== 'string') {
            throw new Error('All values in substrate search event attributes must be strings');
        }
    });

    if (batch === null) {
        // if we don't yet have a batch, create one, and
        // wait 5sec before logging the batch
        batch = <EventsBatch>{};
        setTimeout(logBatch(substrateSearchScenario), 5000);
    }

    // Ensure we have an initialized batch, and add our event
    // to the right traceId key
    batch[traceId] = (batch[traceId] || []).concat(event);
}

export function logBatch(substrateSearchScenario: SubstrateSearchScenario) {
    return () => {
        // transform the EventsBatch into the expected server schema
        // FROM: [{'traceId1': [eventA, eventB]}, {'traceId2': [eventC]}
        // TO: [{ Key: 'traceId1', Value: [eventA, eventB]}, {Key: 'traceId2': Value: [eventC]}]
        const body = Object.keys(batch).reduce((eventGroups, traceId) => {
            eventGroups.push({ Key: traceId, Value: batch[traceId] });
            return eventGroups;
        }, []);

        // reset the batch
        batch = null;

        const defaultParams = { scenario: substrateSearchScenario };
        const params = buildQueryParams(defaultParams);

        makePostRequest(
            `${getSubstrateSearchEndpoint('events')}?${params}`,
            body,
            undefined /* correlationId */,
            undefined /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            undefined /* sendPayloadAsBody */,
            /* 3S does not need auth cookies so omitting them will decrease request header size */
            false /* includeCredentials */
        );
    };
}

export function setBatchForTest(testBatch: EventsBatch) {
    batch = testBatch;
}
